import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.authoring.text_units');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { formatKstDateTime } from "src/libs/portal/season/time";

@Component({
    selector: 'wiz-page-authoring-text_units',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.authoring.text_units/view.scss */
:host {
  display: block;
}

.text-unit-page {
  color: #17231f;
}

.page-heading {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  margin-bottom: 20px;
}

.page-heading h1 {
  margin: 4px 0 8px;
  font-size: 30px;
  letter-spacing: -0.04em;
}

.page-heading p {
  margin: 0;
  color: #687670;
}

.page-heading p strong {
  color: #21805f;
}

.eyebrow {
  color: #17865e !important;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.16em;
}

.refresh-button {
  border: 1px solid #d6dfdb;
  border-radius: 10px;
  padding: 10px 15px;
  background: #fff;
  color: #33433d;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 14px;
}

.summary-grid article {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 16px 18px;
  border: 1px solid #e0e7e4;
  border-radius: 14px;
  background: #fff;
}

.summary-grid span {
  color: #71807a;
  font-size: 10px;
  font-weight: 750;
  letter-spacing: 0.06em;
}

.summary-grid strong {
  margin: 4px 0 2px;
  color: #1c342b;
  font-size: 24px;
}

.summary-grid strong.module-name {
  overflow: hidden;
  color: #187b58;
  font-family: monospace;
  font-size: 15px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.summary-grid small {
  color: #95a09c;
  font-size: 9px;
}

.filter-panel {
  margin-bottom: 16px;
  padding: 17px;
  border: 1px solid #dce6e1;
  border-radius: 15px;
  background: #f8fbfa;
}

.search-row {
  display: flex;
  align-items: flex-end;
  gap: 10px;
}

.keyword-field {
  flex: 1;
}

.filter-panel label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.filter-panel label > span {
  color: #52625c;
  font-size: 10px;
  font-weight: 750;
}

.filter-panel input, .filter-panel select {
  min-width: 0;
  height: 40px;
  border: 1px solid #d5dfda;
  border-radius: 9px;
  padding: 0 11px;
  background: #fff;
  color: #273832;
}

.search-button {
  height: 40px;
  border: 0;
  border-radius: 9px;
  padding: 0 22px;
  background: #147c58;
  color: #fff;
  font-weight: 750;
}

.filter-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(120px, 1fr)) auto;
  gap: 9px;
  align-items: end;
  margin-top: 11px;
}

.reset-button {
  height: 40px;
  border: 1px solid #d2ddd8;
  border-radius: 9px;
  padding: 0 13px;
  background: #fff;
  color: #66756f;
  white-space: nowrap;
}

.reset-button:disabled {
  opacity: 0.5;
}

.state-card {
  padding: 34px;
  border: 1px dashed #cbd8d2;
  border-radius: 16px;
  background: #fff;
  color: #62716b;
  text-align: center;
}

.state-card strong {
  display: block;
  color: #263630;
  font-size: 18px;
}

.state-card p {
  margin: 7px 0 0;
}

.result-panel {
  overflow: hidden;
  border: 1px solid #dce5e1;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(27, 55, 44, 0.04);
}

.result-panel > header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 18px;
  border-bottom: 1px solid #e7edea;
}

.result-panel > header span {
  color: #18845f;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.15em;
}

.result-panel > header h2 {
  margin: 3px 0 0;
  font-size: 18px;
}

.result-panel > header small {
  color: #8a9792;
}

.unit-list {
  display: grid;
}

.unit-card {
  display: grid;
  grid-template-columns: minmax(175px, 0.65fr) minmax(300px, 1.7fr) auto;
  gap: 18px;
  width: 100%;
  padding: 17px 18px;
  border: 0;
  border-bottom: 1px solid #edf1ef;
  background: #fff;
  color: inherit;
  text-align: left;
  transition: background 0.16s ease;
}

.unit-card:last-child {
  border-bottom: 0;
}

.unit-card:hover {
  background: #f8fbfa;
}

.unit-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
}

.unit-meta span {
  color: #197a58;
  font-size: 9px;
  font-weight: 800;
}

.unit-meta strong {
  overflow: hidden;
  max-width: 100%;
  margin: 5px 0 3px;
  color: #30443c;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.unit-meta em {
  padding: 2px 5px;
  border-radius: 5px;
  background: #edf4f1;
  color: #567067;
  font-size: 9px;
  font-style: normal;
}

.unit-meta small {
  margin-top: 7px;
  color: #8b9692;
  font-size: 9px;
}

.unit-copy {
  min-width: 0;
}

.unit-copy > div:first-child {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: baseline;
}

.unit-copy h3 {
  overflow: hidden;
  margin: 0;
  color: #20362e;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.unit-copy > div:first-child span {
  color: #929d99;
  font-size: 9px;
  white-space: nowrap;
}

.unit-copy p {
  display: -webkit-box;
  overflow: hidden;
  margin: 7px 0 9px;
  color: #5f7069;
  font-size: 11px;
  line-height: 1.65;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.flag-row {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.flag {
  display: inline-flex;
  padding: 3px 6px;
  border-radius: 5px;
  font-size: 8px;
  font-weight: 750;
}

.flag.clean {
  background: #e8f6f0;
  color: #217b5b;
}

.flag.warning {
  background: #fff1e7;
  color: #a35b2b;
}

.open-mark {
  align-self: center;
  color: #278363;
  font-size: 10px;
  font-weight: 750;
  white-space: nowrap;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}

.pagination button {
  border: 1px solid #d4dfda;
  border-radius: 8px;
  padding: 8px 13px;
  background: #fff;
  color: #3d5149;
}

.pagination button:disabled {
  opacity: 0.4;
}

.pagination span {
  color: #6d7a75;
  font-size: 11px;
}

.detail-scrim {
  position: fixed;
  z-index: 40;
  inset: 0;
  background: rgba(17, 31, 26, 0.28);
}

.detail-panel {
  position: fixed;
  z-index: 41;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(980px, 94vw);
  overflow-y: auto;
  padding: 24px;
  background: #fff;
  box-shadow: -16px 0 42px rgba(17, 36, 29, 0.18);
}

.detail-panel > header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 17px;
  border-bottom: 1px solid #e4ebe8;
}

.detail-panel > header span {
  color: #18845f;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.14em;
}

.detail-panel > header h2 {
  margin: 4px 0 0;
  font-size: 22px;
}

.detail-panel > header button {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  background: #eef3f1;
  color: #4f625a;
  font-size: 22px;
}

.detail-panel dl {
  margin: 18px 0;
  border: 1px solid #e1e8e5;
  border-radius: 12px;
}

.detail-panel dl div {
  display: grid;
  grid-template-columns: 105px 1fr;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid #edf1ef;
}

.detail-panel dl div:last-child {
  border-bottom: 0;
}

.detail-panel dt {
  color: #82908a;
  font-size: 10px;
}

.detail-panel dd {
  overflow-wrap: anywhere;
  margin: 0;
  color: #354941;
  font-size: 11px;
}

.detail-panel code {
  color: #177856;
  font-size: 10px;
}

.detail-flags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 17px;
}

.detail-flags strong {
  margin-right: 5px;
  color: #43564f;
  font-size: 11px;
}

.full-text {
  border-radius: 13px;
  padding: 16px;
  background: #f6f9f8;
}

.full-text > div {
  display: flex;
  justify-content: space-between;
  color: #34483f;
  font-size: 11px;
}

.full-text > div span {
  color: #87948f;
}

.full-text pre {
  margin: 13px 0 0;
  color: #34473f;
  font-family: inherit;
  font-size: 12px;
  line-height: 1.8;
  white-space: pre-wrap;
  word-break: break-word;
}

.detail-loading {
  padding: 60px 20px;
  color: #6c7b75;
  text-align: center;
}

.correction-workspace, .correction-history {
  margin-top: 18px;
  border: 1px solid #dce6e1;
  border-radius: 14px;
  padding: 17px;
  background: #fff;
}

.correction-workspace > header, .correction-history > header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 14px;
}

.correction-workspace > header span, .correction-history > header span {
  color: #16805b;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.14em;
}

.correction-workspace h3, .correction-history h3 {
  margin: 3px 0 0;
  color: #253b32;
  font-size: 16px;
}

.correction-workspace header p {
  margin: 5px 0 0;
  color: #75827d;
  font-size: 10px;
}

.correction-workspace header em {
  border-radius: 999px;
  padding: 5px 9px;
  background: #edf6f2;
  color: #267559;
  font-size: 9px;
  font-style: normal;
  white-space: nowrap;
}

.suggestion-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  margin-bottom: 14px;
  border: 1px solid #cce5da;
  border-radius: 11px;
  padding: 11px 12px;
  background: #f1faf6;
}

.suggestion-card strong {
  color: #236649;
  font-size: 11px;
}

.suggestion-card p {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin: 5px 0 0;
}

.suggestion-card p span {
  border-radius: 5px;
  padding: 3px 6px;
  background: #fff;
  color: #527066;
  font-size: 8px;
}

.suggestion-card button {
  border: 0;
  border-radius: 8px;
  padding: 8px 11px;
  background: #177d59;
  color: #fff;
  font-size: 10px;
  font-weight: 750;
  white-space: nowrap;
}

.correction-readonly {
  border-radius: 9px;
  padding: 12px;
  background: #f5f7f6;
  color: #66756f;
  font-size: 11px;
}

.correction-compare, .history-compare {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.correction-compare article, .correction-compare > label, .history-compare article {
  min-width: 0;
  border: 1px solid #e0e7e4;
  border-radius: 11px;
  padding: 12px;
  background: #f8faf9;
}

.correction-compare article > div, .correction-compare label > div {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: #44574f;
  font-size: 10px;
}

.correction-compare article > div span, .correction-compare label > div span {
  color: #8b9692;
}

.correction-compare pre, .history-compare pre {
  overflow: auto;
  max-height: 310px;
  margin: 10px 0 0;
  color: #40534b;
  font-family: inherit;
  font-size: 11px;
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-word;
}

.correction-compare textarea {
  box-sizing: border-box;
  width: 100%;
  min-height: 310px;
  margin-top: 10px;
  border: 1px solid #cfdcd6;
  border-radius: 8px;
  padding: 10px;
  resize: vertical;
  background: #fff;
  color: #293d35;
  font-family: inherit;
  font-size: 11px;
  line-height: 1.7;
}

.correction-fields {
  display: grid;
  grid-template-columns: minmax(190px, 0.7fr) minmax(280px, 1.3fr);
  gap: 10px;
  margin-top: 12px;
}

.correction-fields label {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.correction-fields span {
  color: #52655d;
  font-size: 9px;
  font-weight: 750;
}

.correction-fields span em {
  color: #ba543d;
  font-style: normal;
}

.correction-fields select, .correction-fields input {
  height: 39px;
  border: 1px solid #d2ddd8;
  border-radius: 8px;
  padding: 0 10px;
  background: #fff;
  color: #33473f;
  font-size: 10px;
}

.resolve-flags {
  margin-top: 12px;
}

.resolve-flags > strong {
  color: #52645d;
  font-size: 10px;
}

.resolve-flags > div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 7px;
}

.resolve-flags label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 1px solid #efd8c7;
  border-radius: 7px;
  padding: 6px 8px;
  background: #fff8f2;
  color: #8a5737;
  cursor: pointer;
  font-size: 9px;
}

.resolve-flags input {
  pointer-events: none;
}

.correction-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 14px;
}

.correction-actions span {
  color: #87938e;
  font-size: 9px;
}

.correction-actions button {
  border: 0;
  border-radius: 9px;
  padding: 10px 15px;
  background: #147c58;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
}

.correction-actions button:disabled, .suggestion-card button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.correction-history > header small {
  color: #8b9692;
  font-size: 9px;
}

.history-layout {
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 12px;
}

.history-layout > nav {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 480px;
  overflow-y: auto;
}

.history-layout > nav button {
  display: flex;
  flex-direction: column;
  gap: 4px;
  border: 1px solid #e0e7e4;
  border-radius: 9px;
  padding: 9px 10px;
  background: #fff;
  color: #43574f;
  text-align: left;
}

.history-layout > nav button.active {
  border-color: #88c4aa;
  background: #eef8f4;
}

.history-layout > nav strong {
  font-size: 10px;
}

.history-layout > nav span {
  color: #899590;
  font-size: 8px;
}

.history-detail {
  min-width: 0;
}

.history-detail > dl {
  margin: 0 0 10px;
}

.history-detail > dl div {
  grid-template-columns: 85px 1fr;
  padding: 8px 10px;
}

.history-compare article > strong {
  color: #43564f;
  font-size: 10px;
}

.history-compare pre {
  max-height: 260px;
}

@media (max-width: 1100px) {
  .filter-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .unit-card {
    grid-template-columns: 160px 1fr;
  }
  .open-mark {
    display: none;
  }
}
@media (max-width: 720px) {
  .page-heading {
    flex-direction: column;
  }
  .summary-grid, .filter-grid {
    grid-template-columns: 1fr;
  }
  .search-row {
    align-items: stretch;
    flex-direction: column;
  }
  .unit-card {
    grid-template-columns: 1fr;
  }
  .unit-copy > div:first-child {
    align-items: flex-start;
    flex-direction: column;
  }
  .correction-compare, .history-compare, .correction-fields, .history-layout {
    grid-template-columns: 1fr;
  }
  .history-layout > nav {
    max-height: 180px;
  }
}`],
})
export class PageAuthoringText_unitsComponent implements OnInit {
    public loading: boolean = true;
    public detailLoading: boolean = false;
    public correctionSaving: boolean = false;
    public items: any[] = [];
    public selected: any = null;
    public selectedHistory: any = null;
    public correctionForm: any = {};
    public search: any = { module_id: '', label: '' };
    public pagination: any = { page: 1, page_size: 20, total: 0, pages: 1 };
    public filterOptions: any = { sources: [], versions: [], unit_types: [], quality_flags: [] };
    public filters: any = this.emptyFilters();

    public sourceGroups: any = {
        CLINICAL_GUIDELINE: '임상진료지침',
        TEXTBOOK: '한의학 교과서',
        CLASSIC_DB: '한의학 고전 DB',
        JOURNAL: '학술논문',
        ABSTRACT: '학술 초록',
        KNOWLEDGE_PORTAL: '전통지식 포털',
        OTHER: '기타'
    };

    constructor(@Inject( Service) public service: Service) { }

    public emptyFilters() {
        return {
            q: '',
            source_id: '',
            version_id: '',
            source_group: '',
            unit_type: '',
            quality_flag: ''
        };
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load(true);
    }

    public currentDataset() {
        return this.service.auth.session.current_dataset || {};
    }

    private async showError(message: string) {
        await this.service.modal.show({
            title: '조회 실패',
            message: message,
            cancel: false,
            action: '확인',
            actionBtn: 'error',
            status: 'error'
        });
    }

    private idempotencyKey() {
        let cryptoApi: any = (window as any).crypto;
        if (cryptoApi && typeof cryptoApi.randomUUID === 'function') {
            return 'text-unit-correction:' + cryptoApi.randomUUID();
        }
        return 'text-unit-correction:' + Date.now() + ':' + Math.random().toString(16).slice(2);
    }

    private newCorrectionForm(item: any) {
        return {
            text: item && item.text ? item.text : '',
            reason_code: '',
            note: '',
            resolved_flags: [],
            idempotency_key: this.idempotencyKey()
        };
    }

    public async load(resetPage: boolean = false) {
        let dataset = this.currentDataset();
        if (!dataset.dataset_id) {
            this.loading = false;
            return;
        }
        if (resetPage) this.pagination.page = 1;
        this.loading = true;
        this.selected = null;
        try {
            let result: any = await this.service.request.post('/api/text-units/list', {
                dataset_id: dataset.dataset_id,
                q: this.filters.q,
                source_id: this.filters.source_id,
                version_id: this.filters.version_id,
                source_group: this.filters.source_group,
                unit_type: this.filters.unit_type,
                quality_flag: this.filters.quality_flag,
                page: this.pagination.page,
                page_size: this.pagination.page_size
            });
            if (result.code !== 200) {
                await this.showError(result.data && result.data.message ? result.data.message : 'Text Unit 목록을 불러오지 못했습니다.');
                return;
            }
            this.items = result.data.items || [];
            this.pagination = result.data.pagination || this.pagination;
            this.filterOptions = result.data.filter_options || this.filterOptions;
            this.search = result.data.search || this.search;
            this.filters.q = result.data.query || this.filters.q;
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public availableVersions() {
        if (!this.filters.source_id) return this.filterOptions.versions || [];
        return (this.filterOptions.versions || []).filter(
            (version: any) => version.source_id === this.filters.source_id
        );
    }

    public sourceChanged() {
        let versions = this.availableVersions();
        if (this.filters.version_id && !versions.find((item: any) => item.id === this.filters.version_id)) {
            this.filters.version_id = '';
        }
    }

    public resetFilters() {
        this.filters = this.emptyFilters();
        this.load(true);
    }

    public hasFilters() {
        return Object.keys(this.filters).some((key: string) => Boolean(this.filters[key]));
    }

    public async openDetail(item: any) {
        this.detailLoading = true;
        try {
            let result: any = await this.service.request.post('/api/text-units/detail', {
                dataset_id: this.currentDataset().dataset_id,
                unit_id: item.id
            });
            if (result.code !== 200) {
                await this.showError(result.data && result.data.message ? result.data.message : 'Text Unit 상세를 불러오지 못했습니다.');
                return;
            }
            this.selected = result.data.item;
            this.correctionForm = this.newCorrectionForm(this.selected);
            this.selectedHistory = (
                this.selected.correction
                && this.selected.correction.history
                && this.selected.correction.history.length
            ) ? this.selected.correction.history[0] : null;
        } finally {
            this.detailLoading = false;
            await this.service.render();
        }
    }

    public async closeDetail() {
        if (this.correctionSaving) return;
        this.selected = null;
        this.selectedHistory = null;
        this.correctionForm = {};
        await this.service.render();
    }

    public async applyCorrectionSuggestion() {
        let suggestion = this.selected && this.selected.correction
            ? this.selected.correction.suggestion : null;
        if (!suggestion || !suggestion.changed) return;
        this.correctionForm.text = suggestion.suggested_text;
        let linebreak = (suggestion.issues || []).some(
            (issue: any) => issue.code === 'BROKEN_LINE_HYPHEN'
        );
        this.correctionForm.reason_code = linebreak ? 'OCR_LINEBREAK' : 'OCR_SPACING';
        await this.service.render();
    }

    public flagResolved(flag: string) {
        return (this.correctionForm.resolved_flags || []).indexOf(flag) >= 0;
    }

    public async toggleResolvedFlag(flag: string) {
        let values = (this.correctionForm.resolved_flags || []).slice();
        let index = values.indexOf(flag);
        if (index >= 0) values.splice(index, 1);
        else values.push(flag);
        this.correctionForm.resolved_flags = values;
        await this.service.render();
    }

    public hasCorrectionChanges() {
        if (!this.selected || !this.correctionForm) return false;
        return String(this.correctionForm.text || '').trim() !== String(this.selected.text || '').trim();
    }

    public correctionReasonLabel(code: string) {
        let reasons = this.selected && this.selected.correction
            ? this.selected.correction.policy.reasons || [] : [];
        let reason = reasons.find((item: any) => item.value === code);
        return reason ? reason.label : code;
    }

    public async selectHistory(item: any) {
        this.selectedHistory = item;
        await this.service.render();
    }

    public async saveCorrection() {
        if (this.correctionSaving || !this.selected || !this.hasCorrectionChanges()) return;
        if (!this.correctionForm.reason_code) {
            await this.showError('교정 사유를 선택해 주세요.');
            return;
        }
        let confirmed = await this.service.modal.show({
            title: 'Text Unit 교정 저장',
            message: '교정 전후 본문과 작업자 이력을 보존하고, 이후 QA 생성에는 교정된 본문을 사용합니다. 저장하시겠습니까?',
            cancel: '취소',
            action: '교정 저장',
            actionBtn: 'success',
            status: 'success'
        });
        if (!confirmed) return;
        this.correctionSaving = true;
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/text-units/correct', {
                dataset_id: this.currentDataset().dataset_id,
                unit_id: this.selected.id,
                expected_hash: this.selected.text_hash,
                text: this.correctionForm.text,
                reason_code: this.correctionForm.reason_code,
                note: this.correctionForm.note,
                resolved_flags: (this.correctionForm.resolved_flags || []).join(','),
                idempotency_key: this.correctionForm.idempotency_key
            });
            if (result.code !== 200 && result.code !== 201) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : 'Text Unit 교정을 저장하지 못했습니다.'
                );
                return;
            }
            let updated = result.data.item;
            this.selected.text = updated.text;
            this.selected.text_chars = updated.text_chars;
            this.selected.text_hash = updated.text_hash;
            this.selected.quality_flags = updated.quality_flags || [];
            this.selected.correction = updated.correction;
            this.correctionForm = this.newCorrectionForm(this.selected);
            this.selectedHistory = (
                updated.correction.history && updated.correction.history.length
            ) ? updated.correction.history[0] : null;
            let listed = this.items.find((item: any) => item.id === this.selected.id);
            if (listed) {
                listed.text_preview = updated.text.length <= 360
                    ? updated.text : updated.text.substring(0, 360).trim() + '…';
                listed.text_chars = updated.text_chars;
                listed.text_hash = updated.text_hash;
                listed.quality_flags = updated.quality_flags || [];
            }
            await this.service.modal.show({
                title: result.data.created ? '교정 저장 완료' : '동일 교정 요청 확인',
                message: '교정 이력과 본문 Hash를 저장했습니다.',
                cancel: false,
                action: '확인',
                actionBtn: 'success',
                status: 'success'
            });
        } finally {
            this.correctionSaving = false;
            await this.service.render();
        }
    }

    public goPage(page: number) {
        if (page < 1 || page > this.pagination.pages || page === this.pagination.page) return;
        this.pagination.page = page;
        this.load(false);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    public groupLabel(value: string) {
        return this.sourceGroups[value] || value || '-';
    }

    public formatDate(value: string) {
        return formatKstDateTime(value, '-');
    }

    public shortHash(value: string) {
        return value ? value.substring(0, 12) : '-';
    }
}

export default PageAuthoringText_unitsComponent;